/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespShopByModule_homepage = {
    readonly shopByModule: {
        readonly title?: string | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly linkData: {
                readonly path: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
            readonly imageUrl: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespShopByModule_homepage";
};
export type HpRespShopByModule_homepage$data = HpRespShopByModule_homepage;
export type HpRespShopByModule_homepage$key = {
    readonly " $data"?: HpRespShopByModule_homepage$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespShopByModule_homepage">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespShopByModule_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "shopByModule",
      "name": "module",
      "storageKey": "module(type:\"shopBy\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "shopBy"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "ShopByModule",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "Product",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "linkData",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "path",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "SeoLink_linkData",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageUrl",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'a3738cdd627e0710ba20f7ef1e2fbc9a';
export default node;
